import React, { useEffect, useState, useRef } from "react";
import {
  Col, Container, Row, Button, Nav, NavItem, NavLink, Spinner, Alert,
} from "@/Components/Common/Tailwind";
import { Link, useNavigate } from "react-router-dom";
import { SITE_ID } from "../../../assets/meta/meta";
import { SloganModal, CarouselModal, SiteDetailEditModal } from "../../../Components/modal/ManagerModal";
import { API } from "../../../api";
import KakaoMap from "../../CampMap/KaKaoMap";
import AmCarousel from "../../../Components/AmCarousel";
import NewsSection from "../../../Components/NewsSection";
import { useUserStore } from "../../../store/store";

function scrollToTargetAdjusted(targetId, offset = 0) {
  var element = document.getElementById(targetId);
  var headerOffset = offset;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}

const Home = (props) => {
  const navigate = useNavigate();
  const navRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  const [site, siteDetail] = useUserStore((state) => [state.site, state.siteDetail]);

  const [sloganText, setSloganText] = React.useState("");
  const [siteName, setSiteName] = React.useState("");

  const [slogan, setSlogan] = React.useState(true);

  const [carousel, setCarousel] = React.useState([]);
  const [carouselModalNumber, setCarouselModalNumber] = React.useState(0);
  const [targetCarousel, setTargetCarousel] = React.useState(-1);

  const [sloganEditModal, setSloganEditModal] = React.useState(false);
  const [carouselEditModal, setCarouselEditModal] = React.useState(false);
  const [mainNoticeCarousel, setMainNoticeCarousel] = React.useState([]);

  const [detailEditModal, setDetailEditModal] = React.useState(false);

  // Loading and error states
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    if (site) {
      setSiteName(site.name);
      setSloganText(site.slogan);
      setIsLoading(false);
      setError(null);
    } else {
      // Wait a bit for site data to load, then show loading state
      const timer = setTimeout(() => {
        if (!site) {
          setIsLoading(true);
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [site]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        const carouselResponse = await API.get(`/sites/carousel/?site=${SITE_ID}`);
        const carouselData = carouselResponse.data;
        setCarousel(carouselData);

        const mainNoticeCarouselResponse = await API.get(`/sites/carousel/?target_app=true`);
        const mainNoticeCarouselData = mainNoticeCarouselResponse.data;
        setMainNoticeCarousel(mainNoticeCarouselData);
      } catch (error) {
        console.error(error);
        setError("데이터를 불러오는데 실패했습니다. 다시 시도해주세요.");
      }
    };

    fetchData();
  }, [retryCount]);

  const [scrolledSection, setScrolledSection] = useState(null);

  // Add scroll event listener to handle sticky nav
  useEffect(() => {
    const handleScroll = () => {
      if (navRef.current) {
        const navPosition = navRef.current.getBoundingClientRect().top;
        if (navPosition <= 0) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }

        const sections = ["hero", "top-info", "gallery_info", "news_info", "detail_info", "using_info", "reservation_info", "map_info"];
        const scrollPosition = window.scrollY + navRef.current.clientHeight;
        const currentSection = sections.find((section) => {
          const sectionElement = document.getElementById(section);
          const _offset = 140;
          if (sectionElement) {
            const sectionTop = sectionElement.getBoundingClientRect().top + window.scrollY - _offset;
            const sectionBottom = sectionTop + sectionElement.clientHeight;
            return scrollPosition >= sectionTop && scrollPosition < sectionBottom;
          }
          return false;
        });
        if (currentSection !== scrolledSection) {
          setScrolledSection(currentSection);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleRetry = () => {
    setRetryCount(prev => prev + 1);
    setError(null);
    setIsLoading(true);
  };

  // Loading state
  if (isLoading && !site) {
    return (
      <Container className="py-5">
        <Row className="justify-center">
          <Col lg={8} className="text-center">
            <Spinner color="primary" size="lg" />
            <div className="mt-3">
              <h5 style={{ fontFamily: "Gmarket-M", color: "#1d1d1d" }}>
                페이지를 불러오고 있습니다...
              </h5>
              <p className="text-muted">잠시만 기다려주세요.</p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  // Error state
  if (error || (!site && !isLoading)) {
    return (
      <Container className="py-5">
        <Row className="justify-center">
          <Col lg={8}>
            <Alert color="warning" className="text-center">
              <div className="mb-3">
                <i className="mdi mdi-alert-circle-outline" style={{ fontSize: "48px", color: "#f7b84b" }}></i>
              </div>
              <h5>사이트 정보를 불러올 수 없습니다</h5>
              <p className="mb-3">
                네트워크 상태를 확인하시거나 잠시 후 다시 시도해주세요.
              </p>
              <div className="flex justify-center gap-2">
                <Button variant="primary" onClick={handleRetry}>
                  다시 시도
                </Button>
                <Button variant="secondary" onClick={() => window.location.reload()}>
                  페이지 새로고침
                </Button>
              </div>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <React.Fragment>
      <Container>
        <Row className="justify-center">
          {/* 메인 공지 캐러셀 */}
          {/* {site.is_managed ? (
              <>
                {mainNoticeCarousel.map((item, idx) => {
                  return (
                    <div key={idx} className="demo-carousel mb-5">
                      {mainNoticeCarousel.length !== 0 ?
                        <AmCarousel interval={3000} items={item.images} style={{ textAlign: "center" }} objectFit="cover" heightRatio={6 / 11} /> : null}
                    </div>
                  );
                })}
              </>
            ) : null} */}

          {/* <div style={{
            position: "fixed", top: "0", left: "0",
            zIndex: "9999", display: "flex",
            color: "#000", fontSize: "16px", fontFamily: "Gmarket-M",
          }}>
            {scrolledSection}
          </div> */}

          <Col lg={12} className="m-0 p-0">
            <div className="m-0" id="hero">
              {carousel?.length ? (
                <div key={carousel[0].id} className="m-0 p-0">
                  {!!props.permission && props.permission.permission > 0 ? <Button
                    className="btn-soft-primary mb-3 position-absolute top-10 start-10"
                    style={{
                      zIndex: "2", fontFamily: "Gmarket-M", backgroundColor: "#f6475f", boxShadow: "none", border: "none", fontSize: "13px",
                      color: "#fff", marginRight: "10px"
                    }}
                    onClick={() => {
                      setCarouselEditModal(!carouselEditModal);
                      setCarouselModalNumber(0);
                      setTargetCarousel(carousel[0].id);
                    }}
                  >
                    1번 베너 그룹 수정하기
                  </Button> : null}
                  <AmCarousel interval={4000} items={carousel[0].images} objectFit="cover" />
                </div>
              ) : (
                <div className="mb-5" style={{ marginTop: "70px" }}>
                  <p className="mb-4" style={{ fontFamily: "Gmarket-M", fontSize: "16px", textAlign: "center", color: "#1d1d1d" }}>
                    준비중 입니다.
                  </p>
                </div>
              )}
            </div>
          </Col>

          {/* Site Information Section */}
          <Col lg={12} className="mt-4 mb-5">
            <div className="site-info-section">

              <div id="top-info" className="top-info">
                <div className="mb-2" style={{
                  display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px",
                }}>
                  <div style={{ display: "block" }}>
                    <h4 style={{ fontFamily: "Gmarket-M", color: "#333", margin: 0, paddingTop: "4px" }}>
                      {siteName}
                    </h4>
                  </div>
                  <div style={{ margin: 0, padding: 0, fontSize: "15px", color: "#333" }}>
                    {siteDetail?.type.name === "camp" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-600 text-white">캠프</span>}
                    {siteDetail?.type.name === "park" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-500 text-white">파크</span>}
                    {siteDetail?.type.name === "village" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-500 text-white">빌리지</span>}
                    {siteDetail?.type.name === "bbq" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-500 text-white">바베큐</span>}
                    {siteDetail?.type.name === "shop" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-cyan-500 text-white">쇼핑</span>}
                    {siteDetail?.type.name === "dev" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-800 text-white">테스트</span>}
                  </div>
                  <div style={{ margin: 0, padding: 0, fontSize: "15px", color: "#333" }}>
                    {/* {siteDetail?.open_state === "open" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-500 text-white">운영중</span>} */}
                    {siteDetail?.open_state === "confirm" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-500 text-white">준비중</span>}
                    {siteDetail?.open_state === "soon" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-cyan-500 text-white">오픈 예정</span>}
                    {siteDetail?.open_state === "wish" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-500 text-white">오픈 희망</span>}
                    {siteDetail?.open_state === "dev" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-800 text-white">개발중</span>}
                    {siteDetail?.open_state === "pause" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-500 text-white">운영 일시정지</span>}
                    {siteDetail?.open_state === "close" && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-500 text-white">영업 종료</span>}
                    {!siteDetail?.open_state && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">정보 없음</span>}
                  </div>
                </div>
                {!!props.permission && props.permission.permission > 0 ? (
                  <Button className="btn-soft-secondary mb-2 position-absolute end-0" onClick={() => setSloganEditModal(!sloganEditModal)} style={{ zIndex: "5" }}>
                    슬로건 수정하기
                  </Button>
                ) : null}
                <p className="mb-3" style={{ fontFamily: "Gmarket-M", fontSize: "16px", color: "#555" }}>
                  {siteDetail?.slogan || "정보 없음"}
                </p>

                {/* address info */}
                <div className="info-item mb-4">
                  <p className="mb-0" style={{ fontSize: "15px", color: "#333" }}>
                    {siteDetail?.address || "정보 없음"}
                  </p>
                </div>
              </div>

              {/* {(siteDetail?.site_category || siteDetail?.short_name) && (
                  <div className="info-item">
                    <p className="mb-0" style={{ fontSize: "15px", color: "#333" }}>{siteDetail.site_category}</p>
                    <p className="mb-0" style={{ fontSize: "15px", color: "#333" }}>{siteDetail.short_name}</p>
                  </div>
                )} */}


              {/* Amenities */}
              {siteDetail?.amenities_info && siteDetail.amenities_info.length > 0 && (
                <div id="amenity_info" className="mb-3">
                  <h5 style={{ fontFamily: "Gmarket-M", fontSize: "14px", color: "#555" }}>편의 시설</h5>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {siteDetail.amenities_info.map((amenity, idx) => (
                      <span
                        key={idx}
                        className="inline-flex items-center rounded font-bold whitespace-nowrap"
                        style={{
                          backgroundColor: "#efefef",
                          color: "#333",
                          padding: "8px 12px",
                          fontSize: "13px"
                        }}
                      >
                        {amenity.name}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {!!props.permission && props.permission.permission > 0 ? (
                <Button className="btn-soft-primary mb-2 end-0" onClick={() => setDetailEditModal(!detailEditModal)} style={{ zIndex: "5" }}>
                  상세정보 수정하기
                </Button>
              ) : null}

              {/* sticky nav bar */}
              <div
                className="sticky-nav-placeholder"
                ref={navRef}
              ></div>
              <div
                className={`sticky-nav`}
                style={{
                  position: isSticky ? 'fixed' : 'relative',
                  top: isSticky ? 60 : 'auto',
                  left: isSticky ? 0 : 'auto',
                  right: isSticky ? 0 : 'auto',
                  zIndex: isSticky ? 1000 : 'auto',
                  width: isSticky ? '100%' : 'auto',
                  // backgroundColor: '#fff',
                  // boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
                  transition: 'all 0.2s ease-in-out',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Nav className="nav-tabs-custom" role="tablist"
                  style={{
                    maxWidth: "640px",
                    width: "100%",
                    margin: "0 auto",
                    display: "flex", justifyContent: "space-evenly", alignItems: "center",
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd",
                    padding: "0",
                    paddingTop: "10px",
                    marginBottom: "10px",
                  }}>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer", color: "#333" }}
                      className={
                        ["nav-link", ["hero", "top-info"].includes(scrolledSection) ? "active" : ""].join(" ")
                      }
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTargetAdjusted("hero", 140);
                      }}
                    >
                      {/* <i className="ri-home-4-line"></i> */}
                      <span className="d-sm-inline">홈</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer", color: "#333" }}
                      className={
                        ["nav-link", scrolledSection === "news_info" ? "active" : ""].join(" ")
                      }
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTargetAdjusted("news_info", 140);
                      }}
                    >
                      <span className="d-sm-inline">소식</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer", color: "#333" }}
                      className={
                        ["nav-link", scrolledSection === "gallery_info" ? "active" : ""].join(" ")
                      }
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTargetAdjusted("gallery_info", 140);
                        // scrollToTargetAdjusted("detail_info", 140);
                      }}
                    >
                      {/* <i className="ri-information-line"></i> */}
                      <span className="d-sm-inline">정보</span>
                    </NavLink>
                  </NavItem>
                  {siteDetail?.detail_info && <NavItem>
                    <NavLink
                      style={{ cursor: "pointer", color: "#333" }}
                      className={
                        ["nav-link", ["detail_info", "using_info"].includes(scrolledSection) ? "active" : ""].join(" ")
                      }
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTargetAdjusted("detail_info", 140);
                        // scrollToTargetAdjusted("using_info", 140);
                      }}
                    >
                      {/* <i className="ri-file-text-line"></i> */}
                      <span className="d-sm-inline">이용정보</span>
                    </NavLink>
                  </NavItem>}
                  {siteDetail?.reservation_info && <NavItem>
                    <NavLink
                      style={{ cursor: "pointer", color: "#333" }}
                      className={
                        ["nav-link", scrolledSection === "reservation_info" ? "active" : ""].join(" ")
                      }
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTargetAdjusted("reservation_info", 140);
                      }}
                    >
                      {/* <i className="ri-bookmark-line"></i> */}
                      <span className="d-sm-inline">예약정보</span>
                    </NavLink>
                  </NavItem>}
                  {siteDetail?.map_marker && <NavItem>
                    <NavLink
                      style={{ cursor: "pointer", color: "#333" }}
                      className={
                        ["nav-link", scrolledSection === "map_info" ? "active" : ""].join(" ")
                      }
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTargetAdjusted("map_info", 140);
                      }}
                    >
                      {/* <i className="ri-map-pin-2-line"></i> */}
                      <span className="d-sm-inline">오시는길</span>
                    </NavLink>
                  </NavItem>}
                </Nav>
              </div>

              {/* Map Image */}
              {siteDetail?.map_image && (
                <div className="mb-3">
                  <h5 style={{ fontFamily: "Gmarket-M", fontSize: "16px", color: "#555" }}>시설 지도</h5>
                  <div className="text-center mt-2">
                    <img
                      src={siteDetail.map_image}
                      alt="시설 지도"
                      className="img-fluid rounded"
                      style={{ maxHeight: "300px" }}
                    />
                  </div>
                </div>
              )}


              {/* News Section */}
              <div id="news_info" className="mt-4 mb-4">
                <NewsSection maxItems={5} />
              </div>


              <div id="gallery_info" >
                {!!props.permission && props.permission.permission > 0 ? (
                  /* carouselQuantity state 초기값은 1로 설정되어 있음  */
                  <>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginBottom: "20px", marginTop: "0" }}>
                      <Button
                        className="btn-soft-primary"
                        style={{ fontFamily: "Gmarket-M", backgroundColor: "#f6475f1a", boxShadow: "none", border: "none", fontSize: "13px", color: "#f6475f", marginRight: "10px" }}
                        onClick={() => {
                          setCarouselEditModal(!carouselEditModal);
                          setCarouselModalNumber(-1);
                        }}
                      >
                        베너 그룹 추가
                      </Button>
                      <Button
                        style={{ fontFamily: "Gmarket-M", backgroundColor: "#f6475f1a", boxShadow: "none", border: "none", fontSize: "13px", color: "#f6475f", marginRight: "10px" }}
                        className="btn-soft-primary"
                        onClick={() => {
                          setCarouselEditModal(!carouselEditModal);
                          setCarouselModalNumber(-2);
                        }}
                      >
                        베너 그룹 순서 수정
                      </Button>
                    </div>
                    {carousel.map((item, idx) => {
                      if (idx === 0) {
                        return null; // 첫 번째 항목은 건너뜁니다.
                      }
                      return (
                        <div key={idx} className=" demo-carousel mb-4">
                          <Button
                            className="btn-soft-primary mb-3 position-absolute top-10 start-0"
                            style={{ zIndex: "2", fontFamily: "Gmarket-M", backgroundColor: "#f6475f", boxShadow: "none", border: "none", fontSize: "13px", color: "#fff", marginRight: "10px" }}
                            onClick={() => {
                              setCarouselEditModal(!carouselEditModal);
                              setCarouselModalNumber(idx);
                              setTargetCarousel(item.id);
                            }}
                          >
                            {idx + 1}번 베너 그룹 수정하기
                          </Button>
                          <AmCarousel interval={4000} items={item.images} objectFit="cover" />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {carousel.map((item, idx) => {
                      if (idx === 0) {
                        return null; // 첫 번째 항목은 건너뜁니다.
                      }
                      return (
                        <div key={idx} className=" demo-carousel mb-2">
                          <AmCarousel interval={4000} items={item.images} objectFit="cover" />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>

              <div className="info-tabs mt-4 mb-4">

                {/* Detail Information Tab */}
                {siteDetail?.detail_info && (
                  <div id="detail_info" className="mb-4">
                    <h5 style={{ fontFamily: "Gmarket-M", fontSize: "16px", color: "#555" }}>시설 정보</h5>
                    <div className="mt-3 px-3">
                      <div style={{ fontSize: "14px" }}
                        dangerouslySetInnerHTML={{ __html: (siteDetail.detail_info) }} />
                    </div>
                  </div>
                )}

                {/* Usage Information Tab */}
                {siteDetail?.using_info && (
                  <div id="using_info" className="mb-4">
                    <h5 style={{ fontFamily: "Gmarket-M", fontSize: "16px", color: "#555" }}>시설 이용 정보</h5>
                    <div className="mt-3 px-3">
                      <div style={{ fontSize: "14px" }}
                        dangerouslySetInnerHTML={{ __html: (siteDetail.using_info) }} />
                    </div>
                  </div>
                )}

                {/* Reservation Information Tab */}
                {siteDetail?.reservation_info && (
                  <div id="reservation_info" className="mb-4">
                    <h5 style={{ fontFamily: "Gmarket-M", fontSize: "16px", color: "#555" }}>예약 정보</h5>
                    <div className="mt-3 px-3">
                      <div style={{ fontSize: "14px", }}
                        dangerouslySetInnerHTML={{ __html: (siteDetail.reservation_info) }} />
                    </div>
                  </div>
                )}

              </div>

            </div>
          </Col>

          <div id="map_info" className="mt-5">
            <KakaoMap
              coordinate={siteDetail?.map_marker}
              siteName={siteDetail?.name}
              siteLogo={siteDetail?.logo}
              address={siteDetail?.address}
              permission={props.permission} />
          </div>

        </Row>
      </Container>

      {/* Updating Slogan Modal */}
      <SloganModal setVisible={setSloganEditModal} visible={sloganEditModal} origin={sloganText} slogan={slogan} setSlogan={setSlogan} site={site.id} navigate={navigate} />

      {/* Updating Carousel Modal */}
      <CarouselModal
        key={targetCarousel}
        modalNumber={carouselModalNumber}
        carouselId={targetCarousel}
        setVisible={setCarouselEditModal}
        visible={carouselEditModal}
        site={site.id}
        navigate={navigate}
        carouselData={carousel}
      />

      <SiteDetailEditModal
        key={site.id}
        id={site.id}
        setVisible={setDetailEditModal}
        visible={detailEditModal}
        navigate={navigate}
      />

    </React.Fragment>
  );
};

export default Home;
